/// <reference path="../../../teva/slideorfade/slideorfade.ts" />
/// <reference path="../../../teva/positioning/positioning.ts" />
/// <reference path="../smooth/smooth.ts" />
/// <reference path="../navigation/navigation.ts" />
/// <reference path="../notifications/notifications.ts" />

namespace OfficeGuy {
    export class Intercom {
        static Visible: boolean;

        static Init(IntercomApplicationID, IntercomUserID, IntercomUserHash, UserID, UserName, UserEmailAddress, CompanyID, CompanyName, ActivePayments) {
            var VisibleUntil = Teva.Storage.LocalStorage_Get("ShowIntercom", true);
            if (VisibleUntil != null)
                VisibleUntil = new Date(VisibleUntil);
            Intercom.Visible = !(VisibleUntil == null || new Date() > VisibleUntil || Common.IsBrowserLowResolution());

            (function () { var w = <any>window; var ic = w.Intercom; if (typeof ic === 'function') { ic('reattach_activator'); ic('update', w.intercomSettings); } else { var d = document; var i = <any>function () { i.c(arguments); }; i.q = []; i.c = function (args) { i.q.push(args); }; w.Intercom = i; var l = function () { var s = d.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://widget.intercom.io/widget/' + IntercomApplicationID; var x = d.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x); }; if (document.readyState === 'complete') { l(); } else if (w.attachEvent) { w.attachEvent('onload', l); } else { w.addEventListener('load', l, false); } } })();
            var Settings = {
                'app_id': IntercomApplicationID,
                'OfficeGuy Authentication Status': (UserID != null ? "Verified" : "Unverified"),
                'hide_default_launcher': !Intercom.Visible
            };
            if (CompanyID != null && CompanyID != '') {
                Settings['OfficeGuy Company Name'] = CompanyName;
                Settings['OfficeGuy Company ID'] = CompanyID;
                Settings['company'] = {
                    'company_id': CompanyID,
                    'name': CompanyName,
                    'monthly_spend': ActivePayments
                };
            }
            if (UserID != null && UserID != '') {
                Settings['user_id'] = IntercomUserID;
                Settings['user_hash'] = IntercomUserHash;
                Settings['name'] = UserName;
                Settings['email'] = UserEmailAddress;
                Settings['OfficeGuy User Name'] = UserName;
                Settings['OfficeGuy User ID'] = UserID;
            }
            var MobileApplication = Teva.Storage.Cookie_Get("X-OG-Mobile");
            if (MobileApplication == null || MobileApplication == '')
                MobileApplication = 'None';
            Settings["SUMIT Mobile Application"] = MobileApplication;

            (<any>window).Intercom('boot', Settings);
            (<any>window).Intercom('onUnreadCountChange', function (unreadCount) {
                if (unreadCount == 0)
                    return;

                var VisibleUntil = new Date();
                VisibleUntil.setDate(VisibleUntil.getDate() + 1);
                Teva.Storage.LocalStorage_Set("ShowIntercom", VisibleUntil, true);
            });

        }
        static Update(NewSettings) {
            if (typeof ((<any>window).Intercom) === "undefined") {
                setTimeout(function () {
                    Intercom.Update(NewSettings);
                }, 250);
                return false;
            }            
            (<any>window).Intercom('update', NewSettings);
        }
        static ShowHide() {
            if (Intercom.Visible) {
                (<any>window).Intercom("hide");
                (<any>window).Intercom('update', {
                    hide_default_launcher: true
                });
                Intercom.Visible = false;
                Teva.Storage.LocalStorage_Set("ShowIntercom", null);
                return false;
            }
            return Intercom.Show();
        }
        static TrackEvent(Event) {
            if (typeof ((<any>window).Intercom) === "undefined") {
                setTimeout(function () {
                    Intercom.TrackEvent(Event);
                }, 250);
                return false;
            }
            (<any>window).Intercom('trackEvent', Event);
            return false;
        }
        static Show(Message?) {
            if (typeof((<any>window).Intercom) === "undefined") {
                setTimeout(function () {
                    Intercom.Show(Message);
                }, 250);
                return false;
            }

            (<any>window).Intercom("show");
            if (Message != null && Message != '')
                (<any>window).Intercom("showNewMessage", Message);
            $(document).trigger("click.Lightbox");

            var VisibleUntil = new Date();
            VisibleUntil.setDate(VisibleUntil.getDate() + 1);
            Teva.Storage.LocalStorage_Set("ShowIntercom", VisibleUntil, true);

            (<any>window).Intercom('update', {
                hide_default_launcher: false
            })
            Intercom.Visible = true;

            return false;
        }
        static PageLoad(): void {
            if ((<any>window).Intercom)
                (<any>window).Intercom("update", { last_request_at: (new Date()).getTime() / 1000 });
        }
    }
}
$(document).on("Teva.PageLoad", function () {
    OfficeGuy.Intercom.PageLoad();
});
